(function () {
  var STORAGE_KEY = 'aesthetLastCollectionUrl';

  function isSafeCollectionPath(path) {
    if (typeof path !== 'string' || path.length < 14 || path.length > 2048) return false;
    if (path.slice(0, 2) === '//') return false;
    if (path.charAt(0) !== '/') return false;
    if (path.indexOf('..') !== -1) return false;
    return /\/collections\/[^/]+/.test(path);
  }

  function apply() {
    var stored;
    try {
      stored = sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return;
    }
    if (!stored || !isSafeCollectionPath(stored)) return;

    document.querySelectorAll('a.continue-shopping[href]').forEach(function (link) {
      link.setAttribute('href', stored);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  document.addEventListener('on:cart:after-merge', apply);
})();
